import { useEffect, useState } from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { chartsTooltipClasses } from "@mui/x-charts";

export default function PieChartPopularSubs(props) {
  const [width, setWidth] = useState(260);
  const [radius, setRadius] = useState(50);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2560) {
        setWidth(335);
        setRadius(65);
      } else if (window.innerWidth < 2560 && window.innerWidth >= 2400) {
        setWidth(315);
        setRadius(60);
      } else if (window.innerWidth < 2400 && window.innerWidth >= 2133) {
        setWidth(280);
        setRadius(55);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setWidth(260);
        setRadius(50);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setWidth(235);
        setRadius(45);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setWidth(210);
        setRadius(40);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setWidth(185);
        setRadius(35);
      } else {
        setWidth(260);
        setRadius(50);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  const sizing = {
    margin: { right: 10, left: 10 },
    width: width,
    height: width,
    legend: { hidden: true },
  };

  return (
    <PieChart
      series={[
        {
          arcLabel: (item) => `${item.value}%`,
          arcLabelMinAngle: 25,
          innerRadius: radius * 0.9,
          paddingAngle: 5,
          cornerRadius: 10,
          highlightScope: { fade: "global", highlight: "item" },
          faded: { additionalRadius: -10, color: "gray" },
          data: props?.data,
          valueFormatter: (v) => (
            <div className="font-bold text-[0.925em]">{v.value}%</div>
          ),
        },
      ]}
      tooltip={{ trigger: "item" }}
      sx={{
        [`& .${pieArcLabelClasses.root}`]: {
          fill: "white",
          fontWeight: 600,
          fontSize: "0.725em",
        },
      }}
      hideLegend={true}
      slotProps={{
        tooltip: {
          sx: {
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.valueCell}`]:
              {
                fontSize: width / 15,
              },
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.labelCell}`]:
              {
                fontSize: width / 15,
              },
          },
        },
      }}
      {...sizing}
      {...props}
    />
  );
}
